import { PropertyDetails } from "../../api/models/project";

// Action types
const SET_SHORTLIST_ARRAY_DATA = 'SET_SHORTLIST_ARRAY_DATA';
const SET_PROPOSAL_STATUS = 'SET_PROPOSAL_STATUS';

// Action creators
export const setShortListPropertyData = (data: PropertyDetails[]) => ({
    type: SET_SHORTLIST_ARRAY_DATA,
    payload: data,
});

export const setProposalTabStatus = (status: boolean) => ({
    type: SET_PROPOSAL_STATUS,
    payload: status,
});

// Initial state
const initialState: any = {
    shortListPropertyArray: [],
    isFromCreateProposal: false
};

// Reducer
export const shortListPopertyReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_SHORTLIST_ARRAY_DATA:
            return {
                ...state,
                shortListPropertyArray: action.payload,
            };
        case SET_PROPOSAL_STATUS:
            return {
                ...state,
                isFromCreateProposal: action.payload,
            };
        default:
            return state;
    }
};

export default shortListPopertyReducer;
